import React, { MouseEventHandler } from 'react'

import OpenFilterButton from '@components/music/filter/OpenFilterButton'
import LayoutChanger from '@components/shared/LayoutChanger'
import SortDropdown from '@components/shared/SortDropdown'
import { usePageApi } from '@providers/PageApiProvider'
import { SearchPageApiResponse } from '@providers/types/api-responses'
import { ViewType } from '@utils/global'

import Tags from './Tags'

interface Props {
  setViewType: (type: ViewType) => void
  viewType: ViewType
  onClickFilter: MouseEventHandler<HTMLButtonElement>
}

const FilterRow: React.FC<Props> = ({
  setViewType,
  viewType,
  onClickFilter,
}: Props): JSX.Element => {
  const { pageData } = usePageApi<SearchPageApiResponse>()
  return (
    <div className="flex flex-col px-4 mt-5 mb-6 w-full">
      <div className="flex flex-row-reverse flex-wrap items-stretch">
        {!!pageData?.count && (
          <>
            <LayoutChanger
              setViewType={setViewType}
              viewType={viewType}
              types={[ViewType.THUMBNAIL, ViewType.LIST]}
            />
            <SortDropdown
              items={[
                { name: 'sort.relevance', queryValue: 'relevance' },
                { name: 'sort.recent', queryValue: 'most_recent' },
                { name: 'sort.title', queryValue: 'title' },
              ]}
              onSortChanged={(_, searchParams) => {
                searchParams.delete('page')
              }}
            />
          </>
        )}
        <OpenFilterButton onClickFilter={onClickFilter} />
        <div className="hidden md:inline-flex flex-1 mr-2 text-base">
          <Tags className="flex h-full" />
        </div>
      </div>
      <div
        className="flex md:hidden overflow-x-auto mx-[-1rem] px-4 mt-2"
        style={{ width: 'calc(100% + 2rem)' }}>
        <Tags />
      </div>
    </div>
  )
}

export default FilterRow
